import Vue from 'vue';
import JQuery from 'jquery';
import debounce from 'lodash/debounce';

export const updateStickyColumnsAndMinWidth = (args) => {
  // Using debounce (timeout function) to make sure UI has been updated
  debounce(() => {
    updateMinWidth();
    updateStickyColumnPosition(args.leftColumns, 'left');
    updateStickyColumnPosition(args.rightColumns, 'right');
  }, 100).call(null);
};

export const updateMinWidth = () => {
  JQuery.each(JQuery('table[min-width]'), function (i, e) {
    let table = JQuery(e);
    table.css('min-width', table.attr('min-width'));
  });
};

const updateStickyColumnPosition = (numOfCols, direction) => {
  let offset = -1;
  for (let i = 1; i <= numOfCols; i++) {
    let className = `.${direction}-sticky-column-${i}`;
    Vue.$logger.debug(`Update  ${direction} offset for ${className} is ${offset}px`);
    setColumnPosition(className, direction, offset);

    // Update new offset for next sticky column
    offset += getColumnWidth(className);
  }
};

const getColumnWidth = (className) => {
  return JQuery(className).outerWidth() || 0;
};

const setColumnPosition = (className, type, position) => {
  JQuery(className).css(type, position + 'px');
};
